// extracted by mini-css-extract-plugin
export default {"topics":"A8Qe98Mv","topicsList":"Oo0d2Rij"};